import { NgModule }       from '@angular/core';
import {Title} from '@angular/platform-browser';
import { CommonModule }   from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule }   from '@angular/forms';
//
import { AdminComponent } from './adminComponent/admin.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { UserComponent } from './user/user.component';
import { AdminHeaderComponent }  from './adminHeader/admin-header.component';
import { AdminFooterComponent }  from './adminFooter/admin-footer.component';
import { OauthComponent }    from './oauth/oauth.component';
import { InviteComponent }    from './invite/invite.component';
import { AccountComponent }    from './account/account.component';
import { AcceptedComponent }    from './accepted/accepted.component';
import { ResetComponent }    from './reset/reset.component';
import { TruncatePipe } from './tag/tag.truncate.pipe';
import { SafeHtmlPipe } from './tag/tag.safehtml.pipe';
import { ChatComponent } from './chat/chat.component';
import { ShareComponent }    from './share/share.component';
//
import { AdminAutoComponent } from './adminAuto/admin-auto.component';
import { AdminSearchComponent } from './adminSearch/admin-search.component';
import { SiloqComponent } from './siloq/siloq.component';
import { TelComponent }    from './tel/tel.component';
//
import {TelService} from '../services/tel.service';
import {TinyService} from '../services/tiny.service';
import {AutoService} from '../services/auto.service';
import {SearchService} from '../services/search.service';
import {DataService} from '../services/data.service';
//
import {UserService} from '../services/user.service';
import { TagService } from '../services/tag-service.service';
import { TopicService } from '../services/topic.service';

const AdminRoutes: Routes = [
  { 
    path: 'admin',  
    component: AdminComponent, 
    children: [
      { path: 'oauth', component: OauthComponent },
      { path: 'invite', component: InviteComponent },
      { path: 'account', component: AccountComponent },
      { path: 'accepted', component: AcceptedComponent },
      { path: 'feedback', component: FeedbackComponent},
      { path: 'user', component: UserComponent},
      { path: 'chat', component: ChatComponent},
      { path: 'share', component: ShareComponent },
      { path: 'reset', component: ResetComponent},
      { path: 'auto', component: AdminAutoComponent},
      { path: 'search', component: AdminSearchComponent},
      { path: 'siloq', component: SiloqComponent},
      { path: 'tel', component: TelComponent },
    ]
  },
];
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(AdminRoutes)
  ],
  exports: [
    RouterModule,
    TruncatePipe,
    SafeHtmlPipe
  ],
  declarations: [
    AdminComponent,
    FeedbackComponent,
    UserComponent,
    AdminFooterComponent,
    AdminHeaderComponent,
    OauthComponent,
    InviteComponent,
    AccountComponent,
    AcceptedComponent,
    ResetComponent,
    ShareComponent,
    ChatComponent,
    AdminAutoComponent,
    AdminSearchComponent,
    SiloqComponent,
    TelComponent,
    TruncatePipe,
    SafeHtmlPipe
  ],
  providers: [
    UserService,
    TagService,
    TopicService,
    TelService,
    TinyService,
    AutoService,
    SearchService,
    DataService
  ]
})
export class AdminModule {}




// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts